<template>
  <div id="agentgoto">
    <div class="title">
      <img src="../../assets/agent/titleword.png"
           alt="" />
    </div>
    <div class="bgimg">
      <img src="../../assets/agent/phone_bg.png"
           alt="" />
    </div>
    <div class="six-spacial-box">
      <div class="six-spacial-title">
        <img src="../../assets/agent/special.png"
             alt="" />
      </div>
      <div class="six-spacial-content">
        <div class="six-spacial-item">
          <img src="../../assets/agent/img-jz.png"
               alt="" />
          <div>精准检索</div>
        </div>
        <div class="six-spacial-item">
          <img src="../../assets/agent/img-fp.png"
               alt="" />
          <div>智慧分屏</div>
        </div>
        <div class="six-spacial-item">
          <img src="../../assets/agent/img-hq.png"
               alt="" />
          <div>智能分类</div>
        </div>
        <div class="six-spacial-item">
          <img src="../../assets/agent/img-biaoji.png"
               alt="" />
          <div>特殊标记</div>
        </div>
        <div class="six-spacial-item">
          <img src="../../assets/agent/img-gl.png"
               alt="" />
          <div>一键获取</div>
        </div>
        <div class="six-spacial-item">
          <img src="../../assets/agent/img-yd.png"
               alt="" />
          <div>智慧云端</div>
        </div>
      </div>
    </div>
    <div class="btn-box">
      <button class="try"
              @click="tryUse">注册</button>
      <button class="buy"
              @click="gotobuy">立即购买</button>
    </div>
    <!-- 申请试用用户端数据录入 -->
    <van-popup v-model="userTryPop"
               @close="closePopup"
               close-icon="close"
               position="left"
               :style="{ height: '100%', width: '100%', backgroundColor: '#F5F5F5' }">
      <div>
        <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }">
          请填写申请试用信息
        </van-divider>
        <van-form ref="form1">
          <van-field v-model="userTryInfo.companyname"
                     label="公司名称"
                     :rules="[{ required: true,trigger:'onBlur',message: '请输入公司名称' }]"
                     maxlength="30"
                     placeholder="请输入公司名称" />
          <van-field readonly
                     clickable
                     name="picker"
                     :value="userTryInfo.industryname"
                     label="选择行业"
                     placeholder="点击选择行业"
                     :rules="[{ required: true,trigger:'onBlur',message: '请选择行业' }]"
                     @click="showPicker = true" />
          <van-popup v-model="showPicker"
                     position="bottom">
            <van-picker show-toolbar
                        :columns="industryList"
                        @confirm="onConfirm"
                        @cancel="showPicker = false" />
          </van-popup>
          <van-field v-model="userTryInfo.username"
                     label="联系人名称"
                     :rules="[{ required: true,trigger:'onBlur', message: '请输入联系人名称' }]"
                     maxlength="20"
                     placeholder="请输入联系人名称" />
          <van-field v-model="userTryInfo.usertel"
                     label="联系人手机"
                     placeholder="请输入联系人手机"
                     :rules="[{
                    required: true,
                    message: '手机号码不能为空',
                    trigger: 'onBlur'},{validator: value => {
                        return mobilePattern.test(value)
                    }, trigger:'onBlur',message: '请输入正确的手机号码' }]" />
        </van-form>
      </div>
      <van-tabbar :border="false"
                  style="
          background-color: #fff;
          diaplay: flex;
          justify-content: center;
          align-items: center;
        ">
        <van-button style="height: 70%; width: 40%"
                    type="info"
                    block
                    round
                    size="small"
                    @click="closePopup">关闭</van-button>
        <div style="width:8%"></div>
        <van-button style="height: 70%; width: 40%;"
                    type="info"
                    block
                    round
                    size="small"
                    @click="submitForm">提交</van-button>
      </van-tabbar>
    </van-popup>
  </div>
</template>

<script>
import { changeWXString } from "../../utils/lib/searchtoobj";

export default {
  data () {
    return {
      userTryPop: false,
      userTryInfo: {
        companyname: '',
        industryname: '',
        username: '',
        usertel: '',
      },
      industryList: ['农、林、牧、渔业',
        '采矿业',
        '制造业',
        '电力、热力、燃气及水生产和供应业',
        '建筑业',
        '批发和零售业',
        '交通运输、仓储和邮政业',
        '住宿和餐饮业',
        '信息传输、软件和信息技术服务业',
        '金融业',
        '房地产业',
        '租赁和商务服务业',
        '科学研究和技术服务业',
        '水利、环境和公共设施管理业',
        '居民服务、修理和其他服务业',
        '教育',
        '卫生和社会工作',
        '文化、体育和娱乐业'],
      showPicker: false,
      mobilePattern: /^1[3456789]\d{9}$/, // 手机号码验证
    };
  },
  created () {
    console.log(this.$route.query);
    this.templogin();
  },
  methods: {
    // 临时登陆
    templogin () {
      this.$http.reqTempLogin().then((resp) => {
        if (resp.rtncode === 1) {
          if (resp.rltcode === 1) {
            if (
              resp.accounttype === 0 &&
             sessionStorage.getItem("userId") === null &&
              this.$cookie.get("cookieObj") === null
            ) {
              this.$store.commit("user/setUserId", resp.userid);
              this.$store.commit("user/setUserGuid", resp.userguid);
              this.$store.commit("user/setRealName", resp.realname);
              this.$store.commit("user/setToken", resp.token);
              this.$store.commit("user/setMobileNum", resp.mobilenum);
              this.$store.commit("user/setAccountType", resp.accounttype);
              this.$store.commit("user/setPermission", resp.permission);
              this.$store.commit("user/setAccountStatus", resp.accountstatus);
              this.$store.commit("user/setShowMsg", resp.showmsg);
              this.$store.commit("user/setMaxOpenNum", resp.maxopendocnum)
              this.$store.commit("user/setOpenNum", resp.opendocnum)
              this.$store.commit("user/setMaxToken", resp.maxtokens)
              this.$store.commit("user/setMallVer", resp.mallver)

              if (resp.permission != null && resp.permission.length > 0) {
                let items = [];
                resp.permission.forEach((item) => {
                  items.push(item.f);
                });
                this.$store.commit("user/setPermissionArray", items);
              }

              localStorage.setItem("userguid", resp.userguid);
              sessionStorage.setItem("token", resp.token);
            }
          }
        }
      });
    },

    //reset submit data
    resetUserTryInfo () {
      this.userTryInfo.companyname = ''
      this.userTryInfo.industryname = ''
      this.userTryInfo.username = ''
      this.userTryInfo.usertel = ''
    },
    /**** 去掉字符串中的特殊字符*/
    excludeSpecial (s) {
      // 去掉转义字符  
      s = s.replace(/[\'\"\\\/\b\f\n\r\t]/g, '');
      // 去掉特殊字符  
      s = s.replace(/[\@\#\$\%\^\&\*\{\}\:\;\"\L\<\>\?]/g, '');
      return s;
    },
    //submit form
    submitForm () {
      this.$refs.form1.validate().then(() => {
        console.log(this.userTryInfo)
        this.tryUse1(this.userTryInfo)
      }).catch(() => {
        this.$toast.fail('提交失败,注册信息中不要包含特殊字符')
      })

    },
    //industry picker
    onConfirm (value) {
      this.userTryInfo.industryname = value;
      this.showPicker = false;
    },
    //closeUserTryInfo
    closePopup () {
      this.resetUserTryInfo()
      this.userTryPop = false
    },
    tryUse () {
      //this.$router.push("/index");
      //this.userTryPop = true
      this.$router.push({
        path: '/index',
        query: {
          reg: true
        }
      })
    },
    // 申请试用
    tryUse1 (usertrydata) {
      this.$http
        .reqPostGetWeixinPromise({
          http_redirct:
            this.$baseConfig.wxRedirectUrl +
            `?agentcode=${this.$route.query.agentcode}`+
            `&logintype=tryuse`+
            `&companyname=${this.excludeSpecial(usertrydata.companyname)}` +
            `&username=${this.excludeSpecial(usertrydata.username)}` +
            `&usertel=${this.excludeSpecial(usertrydata.usertel)}` +
            `&industryname=${this.excludeSpecial(usertrydata.industryname)}`,
        })
        .then((res) => {
          console.log("注册===>", res);
          if (res.item.url) {
            let newUrl = changeWXString(res.item.url);
            console.log(newUrl);
            location.href = newUrl;
          } else {
            warningNotify(res.rtndesc, this);
          }
        })
        .catch((err) => {
          console.log("微信授权出错====>", err);
          return;
        });
    },
    // 立即购买
    gotobuy () {
      this.$http
        .reqPostGetWeixinPromise({
          http_redirct:
            this.$baseConfig.wxRedirectUrl+
            `?agentcode=${this.$route.query.agentcode}&logintype=gotobuy`,
        })
        .then((res) => {
          if (res.item.url) {
            let newUrl = changeWXString(res.item.url);
            location.href = newUrl;
          } else {
            warningNotify(res.rtndesc, this);
          }
        })
        .catch((err) => {
          console.log("微信授权出错====>", err);
          return;
        });
    },
  },
};
</script>

<style lang="less" scope>
#agentgoto {
  min-height: 100%;
  padding-bottom: 60px;
  background-color: #222;
}
.title {
  padding-top: 30px;

  img {
    display: block;
    width: 90%;
    margin: 0 auto;
  }
}

.bgimg {
  img {
    display: block;
    width: 90%;
    margin: 0 auto;
  }
}

.six-spacial-box {
  .six-spacial-title {
    img {
      display: block;
      width: 50%;
      margin: 0 auto;
    }
  }
  .six-spacial-content {
    display: flex;
    flex-wrap: wrap;
    .six-spacial-item {
      margin-top: 40px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 33.3%;
      img {
        width: 40px;
        height: 40px;
      }
      div {
        color: #c79e7b;
      }
    }
  }
}
.btn-box {
  display: flex;
  justify-content: space-around;
  margin-top: 40px;
  button {
    font-size: 16px;
    width: 132px;
    height: 40px;
    border-radius: 20px;
    background-color: transparent;
  }
  .try {
    border: 1px solid #efba8d;
    color: #efba8d;
  }
  .buy {
    background: linear-gradient(0deg, #efba8d, #f9e0c4);
    color: #401f0a;
    border: transparent;
  }
}
</style>
